import { createReducer } from 'utils/ReduxUtils';

import type { WrapperReducerConfig } from './reducers.types';
import { isStartRequest, isSuccessRequest, isFailureRequest } from './utils';

const loading = (actionRoot: string, { reducers = {}, matchers = [], global: config }: WrapperReducerConfig<boolean> = {}) =>
  createReducer(false, reducers, [
    {
      matcher: isStartRequest(actionRoot, config),
      reducer: () => true,
    },
    {
      matcher: isSuccessRequest(actionRoot, config),
      reducer: () => false,
    },
    {
      matcher: isFailureRequest(actionRoot, config),
      reducer: () => false,
    },
    ...matchers,
  ]);

export default loading;
